import React from 'react';
import { LEGAL_ENTITY, LEGAL_PAGES } from './legalEntity';

const E = LEGAL_ENTITY;

// Compliance footer: legal entity name, CIN, registered address, and links to
// all four legal pages. Rendered on every top-level view (landing, category
// browse, Watch Now) so a payment-gateway reviewer can reach the policies from
// the homepage — not only via the in-app LEGAL content tab.
//
// Links navigate by setting window.location.hash; AppMain's hash listener maps
// #terms/#privacy/#refund/#grievance to the corresponding full-page view, and
// each hash is a stable, directly-shareable URL.
export default function LegalFooter({ style }) {
  const go = (hash) => { try { window.location.hash = hash; window.scrollTo(0, 0); } catch (e) {} };
  return (
    <footer
      role="contentinfo"
      style={{
        borderTop: '1px solid rgba(212,168,67,0.18)',
        background: '#0a0500',
        color: '#8a7c60',
        fontFamily: "'Barlow', sans-serif",
        padding: '28px 5% 34px',
        textAlign: 'center',
        ...style,
      }}
    >
      <nav style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 18px', justifyContent: 'center', marginBottom: 16 }}>
        {LEGAL_PAGES.map((p) => (
          <a
            key={p.key}
            href={p.hash}
            onClick={(e) => { e.preventDefault(); go(p.hash); }}
            style={{ color: '#d4a843', textDecoration: 'none', fontSize: 13, fontWeight: 700, letterSpacing: 0.3 }}
          >
            {p.label}
          </a>
        ))}
      </nav>

      <div style={{ fontSize: 12.5, lineHeight: 1.7, color: '#9a8a6a', maxWidth: 720, margin: '0 auto' }}>
        <div style={{ color: '#c8b89a', fontWeight: 700 }}>{E.name}</div>
        <div>CIN: {E.cin}</div>
        <div>{E.address}</div>
        <div>
          <a href={`mailto:${E.supportEmail}`} style={{ color: '#b8985a', textDecoration: 'none' }}>{E.supportEmail}</a>
          {' '}&nbsp;•&nbsp;{' '}{E.supportPhone}
        </div>
      </div>

      <div style={{ fontSize: 11.5, color: '#6a5c48', marginTop: 14 }}>
        © 2026 {E.name}. All rights reserved.
      </div>
    </footer>
  );
}
